import React from 'react';
import AutoCompleteFilter from './../AutoComplete/AutoCompleteFilter';

export const NoteCustomFilterListOptions = (col) => {
  return {
    render: (v) => {
      let value = v?.toString() || '';

      if (value !== '') {
        const regex = /(<([^>]+)>)/gi;
        value = value?.replace(regex, '  ');
        value = value.replace(/\s{2,}/g, ' ').trim();
        if (value.length > 50) {
          value = value.substring(0, 50) + '...';
        }
      }

      return v.toString() !== '' ? `${col.label}: ${value}` : [];
    },
    update: (filterList, filterPos, index) => {
      if (filterPos === 0) {
        filterList[index].splice(filterPos, 1, '');
      } else if (filterPos === 1) {
        filterList[index].splice(filterPos, 1);
      } else if (filterPos === -1) {
        filterList[index] = [];
      }
      return filterList;
    },
  };
};

export const NoteFilterOptions = {
  logic: (value, filters) => {
    if (filters.length > 0 && filters[0] !== '') {
      return !filters.includes(value);
    }
    return false;
  },
  display: (filterList, onChange, index, column, filterData) => {
    return (
      <AutoCompleteFilter
        freeSolo={true}
        name={column.name}
        label={column.label}
        value={filterList[index][0] || ''}
        onChange={(event) => {
          filterList[index][0] = event.currentTarget.value;
          onChange(filterList[index], index, column);
        }}
        options={filterData[index]}
        filterType={'note'}
      />
    );
  },
};

export default {
  NoteFilterOptions,
  NoteCustomFilterListOptions,
};
